import React, { Suspense } from "react";
import { Outlet } from "react-router";
import type { RouteObject } from "react-router";
import LoadingScreen from "../../shared/components/Loading";
import NotFound from "../../shared/components/NotFound";
import { lazyWithRetry } from "../../shared/components/ChunkErrorBoundary";
import RequireRole, { ANY_ROLE } from "../auth/components/RequireRole";

const DataEnteringRoute = lazyWithRetry(() => import("./routes/dataEntering"));

const DataEnteringLayout = () => (
    <Suspense fallback={<LoadingScreen />}>
        <Outlet />
    </Suspense>
);

export const dataEnteringRoutes: RouteObject[] = [
    {
        element: <RequireRole roles={ANY_ROLE} />,
        children: [
            {
                element: <DataEnteringLayout />,
                children: [
                    { index: true, element: <DataEnteringRoute /> },
                    { path: "*", element: <NotFound /> },
                ],
            },
        ],
    },
];
